import { Component, effect, input, output, signal } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatIconModule } from '@angular/material/icon';

export type LeftSidebarTab = 'collars' | 'animals';

@Component({
  selector: 'vectronic-left-sidebar-tabs',
  templateUrl: './left-sidebar-tabs.component.html',
  styleUrls: ['./left-sidebar-tabs.component.scss'],
  imports: [MatButtonModule, MatCardModule, MatIconModule],
})
export class LeftSidebarTabsComponent {
  width = input<number>(250);
  initialTab = input<LeftSidebarTab>('collars');
  primaryTabLabel = input<string>('Collars');
  secondaryTabLabel = input<string>('Animals');
  showSecondaryTab = input<boolean>(true);

  sidebarToggle = output<boolean>();
  tabChange = output<LeftSidebarTab>();

  isLeftSidebarHidden = signal(false);
  selectedTab = signal<LeftSidebarTab>('collars');

  constructor() {
    effect(() => {
      this.selectedTab.set(this.initialTab());
    });
  }

  selectTab(tab: LeftSidebarTab) {
    if (this.selectedTab() === tab) {
      return;
    }

    this.selectedTab.set(tab);
    this.tabChange.emit(tab);
  }

  toggleLeftSidebarVisibility() {
    this.open(!this.isLeftSidebarHidden());
  }

  open(isHidden: boolean) {
    this.isLeftSidebarHidden.set(isHidden);
    this.sidebarToggle.emit(isHidden);
  }
}
